 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, NumConv, isEnabled, isNumber } from '../modules/appLibrary';
import { styled } from '@material-ui/core/styles';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption, setchangeurl } from '../modules/formstore';

const INVOICE_NO_SEARCH_CHANGE_URL = "common/GetSearchMasterList=ExpenseList/GetSearchMasterList";

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const ExpenseList = props => {

    const panelsdef = [];
    const formid = getformid("ExpenseList", props.location.search);
    const controller = getcontroller("ExpenseList", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const menuinfo = useSelector(state => state.form.menuinfo);

    const fnc = useRef();
    const searchChangeUrlBackupRef = useRef([]);
    const searchRoutingActiveRef = useRef(false);

    //データ
    const entrydataRef = useRef(null);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const changeurl = useSelector(state => state.form.changeurl);
    const ComFunc = React.forwardRef(ComFunction);

    useEffect(() => {
        const current = Array.isArray(changeurl) ? changeurl : [];
        const routed = current.some((value) => value === INVOICE_NO_SEARCH_CHANGE_URL);
        if (!routed) {
            if (!searchRoutingActiveRef.current) {
                searchChangeUrlBackupRef.current = [...current];
            }
            const nextChangeUrl = current.filter((value) =>
                typeof value !== "string" || value.toLowerCase().indexOf("common/getsearchmasterlist=") !== 0
            );
            nextChangeUrl.push(INVOICE_NO_SEARCH_CHANGE_URL);
            dispatch(setchangeurl(nextChangeUrl));
            searchRoutingActiveRef.current = true;
        }
    }, [changeurl, dispatch]);

    useEffect(() => {
        return () => {
            if (!searchRoutingActiveRef.current) return;
            dispatch(setchangeurl(searchChangeUrlBackupRef.current));
            searchRoutingActiveRef.current = false;
        };
    }, [dispatch]);

    const actionurl = {
        "update": "Forms/Update",
        "getlist": "ExpenseList/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]



    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
           >
            </MasterBase>
        </div>
    );
};


